// extracted by mini-css-extract-plugin
export default {"input-header":"Select_input-header__EbXBv","input-error-label":"Select_input-error-label__m6DoS","invalid-input":"Select_invalid-input__8iiAK"};